<template>
  <a
    v-if="product.upsellToGo3"
    :href="url"
    class="c-upsell-button o-button o-button--player"
    :class="{ 'c-upsell-button--embedded': isEmbedded }"
    target="_blank"
  >
    <span class="o-button__label c-upsell-button__label">
      {{ $t('player.upsell') }}
    </span>
  </a>
</template>

<script>
  export default {
    name: 'UiUpsellButton',
    props: {
      product: Object,
      isEmbedded: Boolean,
    },
    data() {
      return {
        info: this.$services.resolve('info'),
      };
    },
    computed: {
      url() {
        const domain = this.info.go3Host;

        return `//${domain}?utm_medium=player-upsell&utm_source=tv3play`;
      },
    },
  };
</script>
